var React = require('react');

function EmailOutline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#bda592;}"),React.createElement("g",{"className":"cls-1","data-name":"Layer 2","key":1},React.createElement("g",{"data-name":"email"},[React.createElement("rect",{"width":"24","height":"24","opacity":"0","key":0}),React.createElement("path",{"d":"M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-.67 2L12 10.75 5.67 6zM19 18H5a1 1 0 0 1-1-1V7.25l7.4 5.55a1 1 0 0 0 .6.2 1 1 0 0 0 .6-.2L20 7.25V17a1 1 0 0 1-1 1z","key":1})]))]);
}

EmailOutline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = EmailOutline;

EmailOutline.default = EmailOutline;
